import get from 'lodash/get';

function getAllPaymentMethods(state) {
  const methods = get(state, ['paymentConfiguration', 'paymentMethods'], {});
  return Object.values(methods);
}

export default getAllPaymentMethods;
